import { render } from "./SeatsArrangement.vue?vue&type=template&id=565eb531"
import script from "./SeatsArrangement.vue?vue&type=script&lang=js"
export * from "./SeatsArrangement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\js\\bible_finder_ui_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__